import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "text-center"
};
const _hoisted_2 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_video_player = _resolveComponent("video-player");
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_b_container = _resolveComponent("b-container");
  const _component_StreamSchedule = _resolveComponent("StreamSchedule");
  return _openBlock(), _createBlock(_component_b_container, {
    fluid: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [$props.id && $props.id > 0 ? (_openBlock(), _createBlock(_component_b_container, {
      key: 0
    }, {
      default: _withCtx(() => [_withDirectives(_createVNode(_component_b_row, null, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
            class: "text-danger text-center mb-4"
          }, [_createElementVNode("h2", null, "Unable to load Live Stream")], -1)]))], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      }, 512), [[_vShow, _ctx.info.error]]), _withDirectives(_createElementVNode("div", null, [_ctx.videoOptions.sources.length > 0 ? (_openBlock(), _createBlock(_component_video_player, {
        key: 0,
        options: _ctx.videoOptions,
        viewedInterval: _ctx.viewedInterval,
        updateInterval: _ctx.updateInterval,
        id: +$props.id,
        livestream: "",
        provider: _ctx.provider
      }, null, 8, ["options", "viewedInterval", "updateInterval", "id", "provider"])) : _createCommentVNode("", true), _createVNode(_component_b_container, null, {
        default: _withCtx(() => [_createVNode(_component_b_row, null, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_b_col, {
            cols: "12"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_b_spinner), _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)), _createTextVNode(_toDisplayString(_ctx.info.message), 1), _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))])], undefined, true),
            _: 1
          }, 512), [[_vShow, _ctx.info.loading]]), !_ctx.info.loading ? (_openBlock(), _createBlock(_component_b_col, {
            key: 0
          }, {
            default: _withCtx(() => [_createElementVNode("h2", null, _toDisplayString(_ctx.livestream.data.title), 1), _ctx.livestream.data.schedule && _ctx.livestream.data.schedule.id > 0 ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.livestream.data.schedule.name), 1)) : _createCommentVNode("", true)], undefined, true),
            _: 1
          })) : _createCommentVNode("", true)], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })], 512), [[_vShow, !_ctx.info.error]])], undefined, true),
      _: 1
    })) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createVNode(_component_StreamSchedule, {
      showNoResults: "",
      showloading: ""
    })])], undefined, true),
    _: 1
  });
}